(function() {
  'use strict';

  var TRACK_API = 'https://app.kallistia.com/api/track-order';
  var SHIPTRACKER_BASE = 'https://kallistia.shiptracker.io/';

  // DOM refs
  var resultsArea = document.getElementById('klTrackResults');
  var cardsContainer = document.getElementById('klTrackCards');
  var resultsTitle = document.getElementById('klTrackResultsTitle');
  var resultsCount = document.getElementById('klTrackResultsCount');
  var errorState = document.getElementById('klTrackError');
  var retryBtn = document.getElementById('klTrackRetry');
  var announcer = document.getElementById('klTrackAnnounce');

  // Cache tracking detail per order to avoid re-fetching
  var trackCache = {};
  var currentEmail = '';

  // ── Helpers ──

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(String(str)));
    return div.innerHTML;
  }

  function formatDate(str) {
    if (!str) return '';
    try {
      var d = new Date(str);
      if (isNaN(d.getTime())) return str;
      return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
    } catch(e) { return str; }
  }

  function formatDateTime(str) {
    if (!str) return '';
    try {
      var d = new Date(str);
      if (isNaN(d.getTime())) return str;
      return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }) + ', ' +
             d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });
    } catch(e) { return str; }
  }

  function announce(msg) {
    if (!announcer) return;
    announcer.textContent = '';
    requestAnimationFrame(function() { announcer.textContent = msg; });
  }

  function setLoading(btn, loading) {
    if (loading) {
      btn.classList.add('loading');
      btn.setAttribute('aria-busy', 'true');
      announce('Looking up your orders\u2026');
    } else {
      btn.classList.remove('loading');
      btn.removeAttribute('aria-busy');
    }
  }

  // ── Status mapping ──
  // Matches help centre's getStatusInfo + renderTrackingDetail logic

  var SVG_TRUCK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2"/><path d="M15 18H9"/><path d="M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14"/><circle cx="17" cy="18" r="2"/><circle cx="7" cy="18" r="2"/></svg>';
  var SVG_CHECK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="m9 12 2 2 4-4"/></svg>';
  var SVG_CLOCK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg>';
  var SVG_CHEVRON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m6 9 6 6 6-6"/></svg>';
  var SVG_PIN = '<svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"/><circle cx="12" cy="10" r="3"/></svg>';
  var SVG_EXTERNAL = '<svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/><polyline points="15 3 21 3 21 9"/><line x1="10" y1="14" x2="21" y2="3"/></svg>';

  function getOrderStatus(order) {
    var t = order.tracking || {};
    var isDelivered = t.deliveryDate || (t.status || '').toLowerCase().indexOf('delivered') !== -1;
    if (isDelivered) return { label: 'Delivered', cls: 'delivered', icon: SVG_CHECK };
    if (order.trackingNumber) return { label: t.status || 'In Transit', cls: 'in-transit', icon: SVG_TRUCK };
    var fs = order.fulfillmentStatus;
    if (!fs || fs === 'unfulfilled' || fs === null) return { label: 'Preparing', cls: 'processing', icon: SVG_CLOCK };
    return { label: 'Processing', cls: 'processing', icon: SVG_CLOCK };
  }

  // ── Tabs ──

  var tabEls = document.querySelectorAll('.kl-track-tab');
  var panels = document.querySelectorAll('.kl-track-panel');

  function switchTab(tabId) {
    tabEls.forEach(function(t) {
      t.setAttribute('aria-selected', 'false');
      t.setAttribute('tabindex', '-1');
    });
    var active = document.getElementById(tabId);
    active.setAttribute('aria-selected', 'true');
    active.removeAttribute('tabindex');

    panels.forEach(function(p) { p.classList.remove('active'); });
    var panelId = active.getAttribute('aria-controls');
    document.getElementById(panelId).classList.add('active');

    var firstInput = document.getElementById(panelId).querySelector('input');
    if (firstInput) firstInput.focus();
  }

  tabEls.forEach(function(t) {
    t.addEventListener('click', function() { switchTab(t.id); });
  });

  // Arrow key navigation within tabs
  var tabsContainer = document.querySelector('.kl-track-tabs');
  if (tabsContainer) {
    tabsContainer.addEventListener('keydown', function(e) {
      var tabs = Array.from(tabsContainer.querySelectorAll('.kl-track-tab'));
      var current = tabs.findIndex(function(t) { return t.getAttribute('aria-selected') === 'true'; });
      var next;

      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { e.preventDefault(); next = (current + 1) % tabs.length; }
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { e.preventDefault(); next = (current - 1 + tabs.length) % tabs.length; }
      else if (e.key === 'Home') { e.preventDefault(); next = 0; }
      else if (e.key === 'End') { e.preventDefault(); next = tabs.length - 1; }

      if (next !== undefined) {
        switchTab(tabs[next].id);
        tabs[next].focus();
      }
    });
  }

  // ── Results display ──

  function showResults() {
    resultsArea.classList.add('active');
    resultsArea.scrollIntoView({ behavior: 'smooth', block: 'start' });
    var firstBtn = cardsContainer.querySelector('.kl-track-card-header');
    if (firstBtn) setTimeout(function() { firstBtn.focus(); }, 400);
  }

  function hideResults() {
    resultsArea.classList.remove('active');
    errorState.classList.remove('active');
    cardsContainer.innerHTML = '';
    resultsTitle.textContent = '';
    resultsCount.textContent = '';
    resultsCount.style.display = '';
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  // ── Render order card HTML ──

  function renderCardHTML(order, index, autoExpand) {
    var status = getOrderStatus(order);
    var products = (order.productTitles || []).slice(0, 2).join(', ');
    if ((order.productTitles || []).length > 2) products += ' +' + (order.productTitles.length - 2) + ' more';
    var orderNum = order.orderNumber || '';
    var cardId = 'klTrackCard' + index;
    var detailId = 'klTrackDetail' + index;
    var expanded = autoExpand ? ' expanded' : '';
    var ariaExpanded = autoExpand ? 'true' : 'false';

    var html = '<article class="kl-track-card kl-track-fade-up' + expanded + '" id="' + cardId + '" style="animation-delay:' + (index * 0.07) + 's">';
    html += '<button class="kl-track-card-header" type="button" aria-expanded="' + ariaExpanded + '" aria-controls="' + detailId + '" data-order-num="' + escapeHtml(orderNum) + '">';
    html += '<div class="kl-track-status-dot ' + status.cls + '" aria-hidden="true">' + status.icon + '</div>';
    html += '<div class="kl-track-card-info">';
    html += '<div class="kl-track-card-product">' + escapeHtml(products || orderNum) + '</div>';
    html += '<div class="kl-track-card-meta">';
    html += '<span>' + escapeHtml(orderNum) + '</span>';
    if (order.createdAt) {
      html += '<span class="kl-track-sep" aria-hidden="true"></span>';
      html += '<span>' + formatDate(order.createdAt) + '</span>';
    }
    html += '</div></div>';
    html += '<span class="kl-track-status-label ' + status.cls + '">' + escapeHtml(status.label) + '</span>';
    html += '<div class="kl-track-expand" aria-hidden="true">' + SVG_CHEVRON + '</div>';
    html += '</button>';
    html += '<div class="kl-track-detail" id="' + detailId + '" role="region" aria-label="Tracking details for order ' + escapeHtml(orderNum) + '">';
    html += '<div class="kl-track-detail-inner">';

    // If we already have tracking data, render it inline
    if (order.tracking && order.tracking.checkpoints && order.tracking.checkpoints.length > 0) {
      html += renderDetailInner(order);
    } else if (!order.trackingNumber) {
      // Unfulfilled — show processing state
      html += renderProcessingInner(order);
    } else if (autoExpand) {
      // Detail response with a tracking number but no live tracking data —
      // degrade gracefully to the carrier tracking link
      html += renderFallbackInner(order);
    } else {
      // Has tracking number but no enriched data yet — will load on expand
      html += '<div class="kl-track-loading" style="padding:24px;text-align:center;color:var(--kl-color-text-muted);font-size:15px;">Loading tracking info\u2026</div>';
    }

    html += '</div></div></article>';
    return html;
  }

  function renderProcessingInner(order) {
    var html = '<div class="kl-track-chips">';
    html += '<div class="kl-track-chip"><span class="kl-track-chip-label">Status</span><span class="kl-track-chip-value">Processing</span></div>';
    if (order.createdAt) {
      html += '<div class="kl-track-chip"><span class="kl-track-chip-label">Ordered</span><span class="kl-track-chip-value">' + formatDate(order.createdAt) + '</span></div>';
    }
    html += '<div class="kl-track-chip"><span class="kl-track-chip-label">Ships Within</span><span class="kl-track-chip-value">1\u20132 days</span></div>';
    html += '</div>';
    html += '<div class="kl-track-timeline"><p class="kl-track-timeline-heading">Order History</p>';
    html += '<ol class="kl-track-tl-list" aria-label="Order history">';
    html += '<li class="kl-track-tl-item"><div class="kl-track-tl-rail" aria-hidden="true"><div class="kl-track-tl-dot current-amber"></div><div class="kl-track-tl-line"></div></div>';
    html += '<div class="kl-track-tl-body"><div class="kl-track-tl-title">Order is being prepared</div>';
    if (order.createdAt) html += '<div class="kl-track-tl-sub"><time>' + formatDateTime(order.createdAt) + '</time></div>';
    html += '</div></li>';
    html += '<li class="kl-track-tl-item"><div class="kl-track-tl-rail" aria-hidden="true"><div class="kl-track-tl-dot"></div></div>';
    html += '<div class="kl-track-tl-body"><div class="kl-track-tl-title muted">Awaiting shipment</div>';
    html += '<div class="kl-track-tl-sub">We\u2019ll email you with tracking once it ships</div></div></li>';
    html += '</ol></div>';
    return html;
  }

  // Carrier tracking URL that works even when live (ParcelsApp) tracking is down
  function fallbackTrackUrl(order) {
    if (order.trackingUrl && /^https?:\/\//i.test(order.trackingUrl)) return order.trackingUrl;
    if (order.trackingNumber) return SHIPTRACKER_BASE + encodeURIComponent(order.trackingNumber);
    return '';
  }

  // Shown when the order has a tracking number but live tracking data is unavailable
  function renderFallbackInner(order) {
    var url = fallbackTrackUrl(order);
    var html = '<div class="kl-track-chips">';
    html += '<div class="kl-track-chip"><span class="kl-track-chip-label">Tracking Number</span><span class="kl-track-chip-value">' + escapeHtml(order.trackingNumber || '') + '</span></div>';
    if (order.trackingCompany) {
      html += '<div class="kl-track-chip"><span class="kl-track-chip-label">Carrier</span><span class="kl-track-chip-value">' + escapeHtml(order.trackingCompany) + '</span></div>';
    }
    html += '</div>';
    html += '<div class="kl-track-fallback">';
    html += '<p class="kl-track-fallback-note">Follow the latest delivery updates on the carrier tracking page.</p>';
    if (url) {
      html += '<a href="' + escapeHtml(url) + '" class="kl-track-fallback-btn" target="_blank" rel="noopener" aria-label="Track your package on the carrier tracking page (opens in new tab)">';
      html += SVG_EXTERNAL + ' Track your package</a>';
    }
    html += '</div>';
    return html;
  }

  function renderDetailInner(order) {
    var t = order.tracking || {};
    var status = getOrderStatus(order);
    var isDelivered = status.cls === 'delivered';
    var html = '';

    // Chips
    html += '<div class="kl-track-chips">';
    if (t.carrier || order.trackingCompany) {
      html += '<div class="kl-track-chip"><span class="kl-track-chip-label">Carrier</span><span class="kl-track-chip-value">' + escapeHtml(t.carriers || t.carrier || order.trackingCompany) + '</span></div>';
    }
    if (isDelivered && t.deliveryDate) {
      html += '<div class="kl-track-chip"><span class="kl-track-chip-label">Delivered</span><span class="kl-track-chip-value">' + formatDate(t.deliveryDate) + '</span></div>';
    } else if (t.estimatedDelivery) {
      html += '<div class="kl-track-chip"><span class="kl-track-chip-label">Est. Delivery</span><span class="kl-track-chip-value">' + formatDate(t.estimatedDelivery) + '</span></div>';
    }
    if (t.transitDays) {
      html += '<div class="kl-track-chip"><span class="kl-track-chip-label">Transit</span><span class="kl-track-chip-value">' + t.transitDays + ' days</span></div>';
    }
    html += '</div>';

    // Timeline
    var cps = t.checkpoints || [];
    if (cps.length > 0) {
      html += '<div class="kl-track-timeline"><p class="kl-track-timeline-heading">Tracking History</p>';
      html += '<ol class="kl-track-tl-list" aria-label="Shipment history">';
      for (var i = 0; i < cps.length; i++) {
        var cp = cps[i];
        var isFirst = i === 0;
        var dotCls = isFirst ? (isDelivered ? 'current-green' : 'current') : 'done';
        var lineCls = 'done';

        html += '<li class="kl-track-tl-item">';
        html += '<div class="kl-track-tl-rail" aria-hidden="true">';
        html += '<div class="kl-track-tl-dot ' + dotCls + '"></div>';
        if (i < cps.length - 1) html += '<div class="kl-track-tl-line ' + lineCls + '"></div>';
        html += '</div>';
        html += '<div class="kl-track-tl-body">';
        html += '<div class="kl-track-tl-title">' + escapeHtml(cp.status || 'Update') + '</div>';
        html += '<div class="kl-track-tl-sub">';
        if (cp.date) html += '<time>' + formatDateTime(cp.date) + '</time>';
        if (cp.location) {
          html += '<span class="kl-track-tl-loc">' + SVG_PIN + ' ' + escapeHtml(cp.location) + '</span>';
        }
        html += '</div></div></li>';
      }
      html += '</ol></div>';
    }

    // Carrier link
    var trackUrl = (t.lastMileUrl && /^https?:\/\//i.test(t.lastMileUrl)) ? t.lastMileUrl : order.trackingUrl;
    var carrierName = t.lastMileService || t.carrier || order.trackingCompany || 'carrier website';
    if (trackUrl && /^https?:\/\//i.test(trackUrl)) {
      html += '<div class="kl-track-carrier-wrap">';
      html += '<a href="' + escapeHtml(trackUrl) + '" class="kl-track-carrier-link" target="_blank" rel="noopener" aria-label="Track this shipment on ' + escapeHtml(carrierName) + ' (opens in new tab)">';
      html += SVG_EXTERNAL + ' Track on ' + escapeHtml(carrierName);
      html += '</a></div>';
    }

    return html;
  }

  // ── Accordion behaviour ──

  function wireAccordion() {
    cardsContainer.querySelectorAll('.kl-track-card-header').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var card = btn.closest('.kl-track-card');
        var orderNum = btn.getAttribute('data-order-num');
        var isExpanded = card.classList.toggle('expanded');
        btn.setAttribute('aria-expanded', String(isExpanded));

        var productText = card.querySelector('.kl-track-card-product');
        announce(isExpanded
          ? (productText ? productText.textContent : 'Order') + ' tracking details expanded'
          : (productText ? productText.textContent : 'Order') + ' collapsed'
        );

        // Lazy-load tracking detail on first expand
        if (isExpanded) {
          var loadingEl = card.querySelector('.kl-track-loading');
          if (loadingEl && orderNum && currentEmail) {
            fetchAndFillTracking(card, orderNum, currentEmail);
          }
        }
      });
    });
  }

  function fetchAndFillTracking(card, orderNum, email) {
    var cacheKey = orderNum + '|' + email;
    if (trackCache[cacheKey]) {
      fillCardDetail(card, trackCache[cacheKey]);
      return;
    }

    fetch(TRACK_API, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ orderNumber: orderNum.replace(/^#/, ''), email: email })
    })
    .then(function(res) { return res.json().then(function(data) { return { ok: res.ok, data: data }; }); })
    .then(function(resp) {
      if (!resp.ok) {
        card.querySelector('.kl-track-loading').textContent = 'Tracking details aren\u2019t available yet.';
        return;
      }
      trackCache[cacheKey] = resp.data;
      fillCardDetail(card, resp.data);
    })
    .catch(function() {
      card.querySelector('.kl-track-loading').textContent = 'We couldn\u2019t load tracking details right now.';
    });
  }

  function fillCardDetail(card, data) {
    var inner = card.querySelector('.kl-track-detail-inner');
    if (!inner) return;
    if (data.tracking && data.tracking.checkpoints && data.tracking.checkpoints.length > 0) {
      inner.innerHTML = renderDetailInner(data);
    } else if (!data.trackingNumber) {
      inner.innerHTML = renderProcessingInner(data);
    } else {
      // Has tracking number but no live tracking data — carrier link fallback
      inner.innerHTML = renderFallbackInner(data);
    }
  }

  // ── API calls ──

  // Mode 1: Email only → order list
  function lookupByEmail(email) {
    hideResults();
    var btn = document.querySelector('#klTrackEmailForm .kl-track-btn');
    setLoading(btn, true);
    currentEmail = email;

    fetch(TRACK_API, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: email })
    })
    .then(function(res) { return res.json().then(function(data) { return { ok: res.ok, data: data }; }); })
    .then(function(resp) {
      setLoading(btn, false);
      if (!resp.ok) {
        showError(resp.data.error || 'We couldn\u2019t complete your request. Please try again.');
        return;
      }
      if (resp.data.mode === 'detail') {
        // API returned a single order detail
        renderSingleOrder(resp.data);
      } else {
        renderOrderList(resp.data.orders);
      }
    })
    .catch(function() {
      setLoading(btn, false);
      showError('We\u2019re having trouble connecting. Please try again in a moment.');
    });
  }

  // Mode 2: Order + Email → single order detail
  function lookupByOrder(orderNum, email) {
    hideResults();
    var btn = document.querySelector('#klTrackOrderForm .kl-track-btn');
    setLoading(btn, true);
    currentEmail = email;

    fetch(TRACK_API, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ orderNumber: orderNum.replace(/^#/, ''), email: email })
    })
    .then(function(res) { return res.json().then(function(data) { return { ok: res.ok, data: data }; }); })
    .then(function(resp) {
      setLoading(btn, false);
      if (!resp.ok) {
        showError(resp.data.error || 'We couldn\u2019t complete your request. Please try again.');
        return;
      }
      renderSingleOrder(resp.data);
    })
    .catch(function() {
      setLoading(btn, false);
      showError('We\u2019re having trouble connecting. Please try again in a moment.');
    });
  }

  // Mode 3: Tracking number → direct lookup
  function lookupByTracking(trackNum) {
    hideResults();
    var btn = document.querySelector('#klTrackNumForm .kl-track-btn');
    setLoading(btn, true);

    // If the number looks plausible, offer a direct carrier link on failure
    var fallbackUrl = trackNum.length >= 5 ? SHIPTRACKER_BASE + encodeURIComponent(trackNum) : '';

    fetch(TRACK_API, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ trackingNumber: trackNum })
    })
    .then(function(res) { return res.json().then(function(data) { return { ok: res.ok, data: data }; }); })
    .then(function(resp) {
      setLoading(btn, false);
      if (!resp.ok) {
        showError(resp.data.error || 'We\u2019re having trouble looking that number up right now.', fallbackUrl);
        return;
      }
      renderSingleTracking(resp.data);
    })
    .catch(function() {
      setLoading(btn, false);
      showError('We\u2019re having trouble connecting. Please try again in a moment.', fallbackUrl);
    });
  }

  // ── Render results ──

  function renderOrderList(orders) {
    if (!orders || orders.length === 0) {
      showError('No orders found for this email address.');
      return;
    }

    resultsTitle.textContent = 'Your orders';
    resultsCount.textContent = orders.length + ' order' + (orders.length !== 1 ? 's' : '');
    resultsCount.style.display = '';

    var html = '';
    for (var i = 0; i < orders.length; i++) {
      html += renderCardHTML(orders[i], i, false);
    }
    cardsContainer.innerHTML = html;
    wireAccordion();
    announce(orders.length + ' order' + (orders.length !== 1 ? 's' : '') + ' found');
    showResults();
  }

  function renderSingleOrder(data) {
    var num = data.orderNumber || '';
    resultsTitle.textContent = 'Order ' + escapeHtml(num);
    resultsCount.style.display = 'none';

    cardsContainer.innerHTML = renderCardHTML(data, 0, true);
    wireAccordion();
    var status = getOrderStatus(data);
    var products = (data.productTitles || []).slice(0, 2).join(', ') || num;
    announce('Order found. ' + products + ', ' + status.label + '.');
    showResults();
  }

  function renderSingleTracking(data) {
    resultsTitle.textContent = 'Shipment found';
    resultsCount.style.display = 'none';

    cardsContainer.innerHTML = renderCardHTML(data, 0, true);
    wireAccordion();
    var status = getOrderStatus(data);
    announce('Shipment found. ' + status.label + '.');
    showResults();
  }

  function showError(msg, fallbackUrl) {
    cardsContainer.innerHTML = '';
    resultsTitle.textContent = '';
    resultsCount.style.display = 'none';
    // Update error message if custom
    var errorP = errorState.querySelector('p');
    if (errorP && msg) errorP.textContent = msg;
    // Optional carrier-link fallback (tracking-number-only searches)
    var oldFallback = document.getElementById('klTrackErrorFallback');
    if (oldFallback && oldFallback.parentNode) oldFallback.parentNode.removeChild(oldFallback);
    if (fallbackUrl) {
      var fb = document.createElement('p');
      fb.className = 'kl-track-error-fallback';
      fb.id = 'klTrackErrorFallback';
      fb.innerHTML = 'You can also try <a href="' + escapeHtml(fallbackUrl) + '" target="_blank" rel="noopener" aria-label="Track this number on the carrier tracking page (opens in new tab)">tracking it directly here</a>.';
      var retryEl = errorState.querySelector('.kl-track-retry');
      if (retryEl) errorState.insertBefore(fb, retryEl);
      else errorState.appendChild(fb);
    }
    errorState.classList.add('active');
    announce(msg || 'No results found.');
    resultsArea.classList.add('active');
    resultsArea.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  // ── Form handlers ──

  var emailForm = document.getElementById('klTrackEmailForm');
  if (emailForm) {
    emailForm.addEventListener('submit', function(e) {
      e.preventDefault();
      var email = document.getElementById('klTrackEmail').value.trim();
      if (!email) return;
      lookupByEmail(email);
    });
  }

  var orderForm = document.getElementById('klTrackOrderForm');
  if (orderForm) {
    orderForm.addEventListener('submit', function(e) {
      e.preventDefault();
      var orderNum = document.getElementById('klTrackOrderNum').value.trim();
      var email = document.getElementById('klTrackOrderEmail').value.trim();
      if (!orderNum || !email) return;
      lookupByOrder(orderNum, email);
    });
  }

  var trackNumForm = document.getElementById('klTrackNumForm');
  if (trackNumForm) {
    trackNumForm.addEventListener('submit', function(e) {
      e.preventDefault();
      var num = document.getElementById('klTrackNum').value.trim();
      if (!num) return;
      lookupByTracking(num);
    });
  }

  // Retry button
  if (retryBtn) {
    retryBtn.addEventListener('click', function() {
      hideResults();
    });
  }

})();
